(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[710],{

/***/ "jEPu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "People", function() { return People; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var People = function People(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    fillRule: "evenodd",
    d: "M18 9.25a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-1.75 4.84a5 5 0 0 1-2.5 0 1 1 0 0 1-.75 1.66c-1 0-1.54.07-1.89.21-.27.12-.51.31-.78.85-.29.58-.56 1.45-.93 2.82l-.44 1.65c-.28 1.06-.6 2.3-1 3.74a1 1 0 1 1-1.92-.54c.39-1.42.7-2.62.98-3.67l.44-1.7c.37-1.35.69-2.41 1.08-3.2.42-.84.97-1.45 1.8-1.8a6.82 6.82 0 0 1 2.48-.36 5 5 0 1 1 4.36 0c.93 0 1.77.07 2.48.37.83.34 1.38.95 1.8 1.79.4.79.71 1.85 1.08 3.2l.44 1.7.98 3.67a1 1 0 1 1-1.92.54 257.04 257.04 0 0 1-1.43-5.39 16.3 16.3 0 0 0-.94-2.82c-.27-.54-.5-.73-.78-.85a5.23 5.23 0 0 0-1.89-.21 1 1 0 0 1-.75-1.66Z",
    clipRule: "evenodd"
  }));
};

/***/ })

}]);